export default "__VITE_ASSET__B3s_lw2W__"